import { FC } from "react";
import { ApplicationStatus } from "shared/types";
import { XCircle } from "untitledui-js-base";

type Props = {
  status: ApplicationStatus;
};

export const ApplicationStatusBanner: FC<Props> = ({ status }) => {
  if (status === ApplicationStatus.Canceled)
    return (
      <div className="flex h-16 items-center border-y border-alpha-100 bg-alpha-40 px-6">
        <XCircle className="mr-2 text-content-500" size="24" />
        <p className="font-bold text-content-500">Application canceled</p>
      </div>
    );

  return null;
};
